import React, { useCallback } from 'react';
import { RootState } from 'app/rootReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { storeExtraFunc } from './extraSlice';
import { useHistory } from 'react-router-dom';
import { Extra } from './types';
import logo from '../../app/logo.jpg';

export default function ExtraComponents(): JSX.Element{
    
    let extra = useSelector(
        (state: RootState) => state.extraSlice
    )
    let house = useSelector(
        (state: RootState) => state.house
    )

    let currentRoom = house.currentRoom
    // const [macroCheck, setMacro] = React.useState(false)
    let macroCheck = extra["macros"]["selected"]
    console.log(macroCheck)
    let networkCheck = extra["accesspoints"]["selected"]
    const dispatch = useDispatch()
    const history = useHistory();
    const Callback = useCallback((val) => history.push(val), [history]);
    console.log(Extra)

    let listExtra = JSON.parse(JSON.stringify(extra))
    console.log(listExtra)

    function saveState(){
        return new Promise((resolve, reject) => {
            dispatch(storeExtraFunc(listExtra))
            resolve(true)
        })
    }

    async function HandleSubmit(destination: string){
        console.log(extra)
        let done = await saveState()
        switch (destination) {
            case "macro":
                Callback("/extra/macro")
                break;
            case "network":
                Callback("/extra/network")
                break;
            case "final":
                Callback("/finalPreview")
                break;
            case "here":
                Callback("/extra")
                break;
            case "tilbake":
                Callback("/room/" + currentRoom)
                break;    
            default:
                break;
        }
    }

    function activateMacro(){
        listExtra["macros"]["selected"] = !listExtra["macros"]["selected"]
        macroCheck = listExtra["macros"]["selected"]
        !macroCheck ? HandleSubmit("here") : HandleSubmit("macro")
        console.log(macroCheck)
    }

    async function activateNetwork(){
        listExtra["accesspoints"]["selected"] = !listExtra["accesspoints"]["selected"]
        networkCheck = listExtra["accesspoints"]["selected"]
        !networkCheck ? HandleSubmit("here") : HandleSubmit("network")
        console.log(networkCheck)
    }

    return(
        <div>
            <div>
                <img src={logo} />
            </div>
            <div className="mainDiv">
                <input 
                    type="checkbox" 
                    id="chkVarme"
                    className="chkBox" 
                    defaultChecked={extra["varmepumpe"]} 
                    onChange={(event) => listExtra["varmepumpe"] = event.currentTarget.checked} 
                /><label className="chkBoxLabel" htmlFor="chkVarme">Varmepumpe</label> <br />

                <input 
                    type="checkbox" 
                    id="chkThin" 
                    className="chkBox" 
                    defaultChecked={extra["knx"]} 
                    onChange={(event) => listExtra["knx"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkThin">ThinKnx</label><br />

                <input 
                    type="checkbox" 
                    id="chk41" 
                    className="chkBox" 
                    defaultChecked={extra["z41"]} 
                    onChange={(event) => listExtra["z41"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chk41">Z41</label><br />

                <input 
                    type="checkbox" 
                    id="chkVer" 
                    className="chkBox" 
                    defaultChecked={extra["weather"]} 
                    onChange={(event) => listExtra["weather"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkVer">Verstasjon</label><br />

                <input 
                    type="checkbox" 
                    id="chkISE" 
                    className="chkBox" 
                    defaultChecked={extra["ISE"]} 
                    onChange={(event) => listExtra["ISE"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkISE">ISE REMOTE</label><br />

                <input 
                    type="checkbox" 
                    id="chkport"
                    className="chkBox" 
                    defaultChecked={extra["porttlf"]} 
                    onChange={(event) => listExtra["porttlf"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkport">Porttelefon</label><br />

                <input 
                    type="checkbox" 
                    id="chkEffekt" 
                    className="chkBox" 
                    defaultChecked={extra["effect"]} 
                    onChange={(event) => listExtra["effect"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkEffekt">Effektstyring</label><br />

                <input 
                    type="checkbox" 
                    id="chklogg" 
                    className="chkBox" 
                    defaultChecked={extra["logging"]} 
                    onChange={(event) => listExtra["logging"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chklogg">Logging av temperatur inne og ute</label><br />

                <input 
                    type="checkbox" 
                    id="chkMovil" 
                    className="chkBox" 
                    defaultChecked={extra["mobile"]} 
                    onChange={(event) => listExtra["mobile"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkMovil">Mobil/PAD losning</label><br />

                <input 
                    type="checkbox" 
                    id="chktimer" 
                    className="chkBox" 
                    defaultChecked={extra["timer"]} 
                    onChange={(event) => listExtra["timer"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chktimer">Timer på stikkontakt</label><br />

                <input 
                    type="checkbox" 
                    id="chkrgbw" 
                    className="chkBox" 
                    defaultChecked={extra["rgbw"]} 
                    onChange={(event) => listExtra["rgbw"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkrgbw">RGBW belysning</label><br />

                <input 
                    type="checkbox" 
                    id="chkvann" 
                    className="chkBox" 
                    defaultChecked={extra["waterdetection"]} 
                    onChange={(event) => listExtra["waterdetection"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkvann">Vanndeteksjon</label><br />

                <input 
                    type="checkbox" 
                    id="chkSolid" 
                    className="chkBox" 
                    defaultChecked={extra["solidstate"]} 
                    onChange={(event) => listExtra["solidstate"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkSolid">Solidstate på varmekabel</label><br />

                <input 
                    type="checkbox" 
                    id="chkkonst" 
                    className="chkBox" 
                    defaultChecked={extra["constantlight"]} 
                    onChange={(event) => listExtra["constantlight"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkkonst">Konstantlys styring</label><br />

                <input 
                    type="checkbox" 
                    id="chksonos" 
                    className="chkBox" 
                    defaultChecked={extra["sonos"]} 
                    onChange={(event) => listExtra["sonos"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chksonos">Integraring med Sonos</label><br />

                <input 
                    type="checkbox" 
                    id="chkute" 
                    className="chkBox" 
                    defaultChecked={extra["outside"]} 
                    onChange={(event) => listExtra["outside"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chkute">Utelys</label><br />

                <input 
                    type="checkbox" 
                    id="chknett" 
                    className="chkBox" 
                    defaultChecked={extra["network"]} 
                    onChange={(event) => {listExtra["network"] = event.currentTarget.checked}}
                /><label className="chkBoxLabel" htmlFor="chknett">Nettverk</label><br />

                <input 
                    type="checkbox"
                    id="chk24" 
                    className="chkBox" 
                    defaultChecked={extra["port24"]} 
                    onChange={(event) => listExtra["port24"] = event.currentTarget.checked}
                /><label className="chkBoxLabel" htmlFor="chk24">24 port switch?</label><br />

                <input 
                    type="checkbox"
                    id="chkakksess" 
                    className="chkBox" 
                    defaultChecked={extra["accesspoints"]["selected"]} 
                    onChange={(event) => {activateNetwork()}}
                /><label className="chkBoxLabel" htmlFor="chkakksess">Aksesspunkt</label><br />

                <div>
                    Antall Aksesspunkt: <input 
                                            type="number"
                                            min="0"
                                            defaultValue={extra["accesspoints"]["amount_access"]} 
                                            onChange={(event) => listExtra["accesspoints"]["amount_access"] = event.currentTarget.value}
                                        />  
                    Antall datapunkt: <input 
                                            type="number"
                                            min="0"
                                            defaultValue={extra["accesspoints"]["amount_data"]} 
                                            onChange={(event) => {listExtra["accesspoints"]["amount_data"] = event.currentTarget.value; HandleSubmit("network")}}
                                        /><br />  <br />
                </div>  
                <input 
                    type="checkbox"
                    id="chkmacro" 
                    className="chkBox" 
                    checked={extra["macros"]["selected"]} 
                    onChange={() => activateMacro()}
                /><label className="chkBoxLabel" htmlFor="chkmacro">Scener/Macros i rom</label><br />
                Antall Scener/Macro: <input 
                                        type="number"
                                        min="0"
                                        style={{visibility: macroCheck ? "visible" : "hidden"}}
                                        defaultValue={extra["macros"]["amount"]} 
                                        onChange={(event) => {listExtra["macros"]["amount"] = event.currentTarget.value; HandleSubmit("macro")}}
                                    /><br />
                
                <button className="btnContinue" style={{visibility: macroCheck ? "visible" : "hidden"}} onClick={() => HandleSubmit("macro")}>Skriv Macroinfo</button> <br />
                <button className="btnContinue" style={{visibility: networkCheck ? "visible" : "hidden"}} onClick={() => HandleSubmit("network")}>Skriv Nettverkinfo</button> <br />
                <button className="btnTilbake" onClick={() => HandleSubmit("tilbake")}>Tilbake</button>
                <button className="btnSave" onClick={() => HandleSubmit("final")}>Til Forhåndsvisning</button>
            </div>            
        </div>
    )
}

